module.exports = __webpack_public_path__ + "static/media/1-1-mobile.102cb6f1.webp";